/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs */

const en_admin_settings_fields_cloudflare_email_sender_email = /** @type {(inputs: Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sender Email`)
};

const zh_admin_settings_fields_cloudflare_email_sender_email = /** @type {(inputs: Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发件地址`)
};

/**
* | output |
* | --- |
* | "Sender Email" |
*
* @param {Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_fields_cloudflare_email_sender_email = /** @type {((inputs?: Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Fields_Cloudflare_Email_Sender_EmailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_fields_cloudflare_email_sender_email(inputs)
	return zh_admin_settings_fields_cloudflare_email_sender_email(inputs)
});
export { admin_settings_fields_cloudflare_email_sender_email as "admin.settings.fields.cloudflare_email_sender_email" }